import React, { useState } from "react";
import { Pressable, Text, View } from "react-native";
import styles from "../MyTicketsScreenStyles";
import { TicketStatus } from "../../../store/slices/ticketingPortalSlice";
import { MyTicketStatusPill } from "../hooks/useMyTicketsListing";
import { useTheme } from "../../../theme";

type Props = {
  activeStatus: "all" | TicketStatus;
  statusPills: MyTicketStatusPill[];
  statusCounts: Record<string, number>;
  onStatusChange: (value: "all" | TicketStatus) => void;
};

const MyTicketsStatusSummary: React.FC<Props> = ({
  activeStatus,
  statusPills,
  statusCounts,
  onStatusChange,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const [hoveredKey, setHoveredKey] = useState<string | null>(null);

  return (
    <View style={[styles.statusSummary, isDark && { backgroundColor: colors.background.surface }]}>
      {statusPills.map((pill) => {
        const active = activeStatus === pill.key;
        const hovered = hoveredKey === pill.key;
        return (
          <Pressable
            key={pill.key}
            // @ts-ignore — onMouseEnter/onMouseLeave are valid on React Native Web
            onMouseEnter={() => setHoveredKey(pill.key)}
            onMouseLeave={() => setHoveredKey(null)}
            style={({ pressed }) => [
              styles.statusPill,
              isDark && !active && { backgroundColor: colors.background.elevated },
              active ? styles.statusPillActive : null,
              !active && hovered ? styles.statusPillHovered : null,
              !active && hovered && isDark ? { backgroundColor: colors.background.page } : null,
              pressed ? styles.statusPillPressed : null,
            ]}
            onPress={() => onStatusChange(pill.key)}
          >
            {pill.dotColor ? (
              <View style={[styles.statusDot, { backgroundColor: pill.dotColor }, active ? styles.statusDotActive : null]} />
            ) : null}
            <Text style={[styles.statusPillLabel, isDark && !active && { color: colors.text.secondary }, active ? styles.statusPillLabelActive : null]}>{pill.label}</Text>
            <Text style={[styles.statusPillCount, isDark && !active && { color: colors.text.secondary, backgroundColor: "rgba(255,255,255,0.08)" }, active ? styles.statusPillCountActive : null]}>
              {statusCounts[pill.key] ?? 0}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
};

export default MyTicketsStatusSummary;
